function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#00A1E0",
  fillRule: "evenodd",
  d: "M11.368 4H.632C.282 4 0 3.744 0 3.428v-.571c0-.316.283-.572.632-.572h1.894c0-.837.195-1.326.627-1.718C3.585.176 4.124 0 5.05 0h1.9c.926 0 1.465.176 1.897.567.433.392.627.88.627 1.718h1.894c.35 0 .632.256.632.572v.571c0 .316-.283.572-.632.572zM7.711 1.504c-.231-.371-.543-.551-.855-.493H5.144c-.312-.058-.624.122-.855.493-.213.405-.316.95-.283 1.496h3.988c.033-.546-.07-1.09-.283-1.496zM10.621 5a.313.313 0 01.313.332l-.551 8.788a.94.94 0 01-.94.879H2.43a.94.94 0 01-.94-.88L.94 5.332a.313.313 0 01.312-.332h9.369zM2.5 7h1l.5 6H3l-.5-6zm6 0h1L9 13H8l.5-6zM6.533 7H7.2l-.333 6H6.2l.333-6zM5.467 7H4.8l.333 6H5.8l-.333-6z"
});

var SvgSalesforceDelete = function SvgSalesforceDelete(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15"
  }, props), _ref);
};

export default SvgSalesforceDelete;